import { ToolbarData } from '@src/core/config/ToolbarTypes'

const defaultToolbarValues: ToolbarData = {
  name: 'DefaultToolbar',
  data: {}
}

export default defaultToolbarValues
